// src/utils/api.js
import axios from "axios";
import { refreshTokenIfNeeded } from "./auth";

const resolveApiBase = () => {
  const configured = process.env.REACT_APP_API_BASE?.replace(/\/$/, "");
  if (configured) return configured;

  if (typeof window !== "undefined") {
    const { protocol, hostname, origin } = window.location;
    const isLocalHost =
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      /^192\.168\.\d{1,3}\.\d{1,3}$/i.test(hostname);

    return isLocalHost ? `${protocol}//${hostname}:5001` : origin;
  }

  return "http://localhost:5001";
};

const API_BASE = resolveApiBase();

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const AUTH_REFRESH_SKIP_PATHS = new Set([
  "/api/login",
  "/api/login/2fa",
  "/api/register",
  "/api/renew-token",
]);

api.interceptors.request.use(
  async (config) => {
    const requestUrl = String(config.url || "");
    const requestPath = new URL(requestUrl, API_BASE).pathname;
    if (config.skipAuthRefresh || AUTH_REFRESH_SKIP_PATHS.has(requestPath)) {
      return config;
    }

    const token = await refreshTokenIfNeeded();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
export { API_BASE };
